//@ts-check
import React from 'react';
import { useFormikContext, Formik } from 'formik';
import { Grid, makeStyles, IconButton } from '@material-ui/core';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import { ProductOptionSchema } from '../LaunchProduct.schema';

import PrimaryButton from '../../../components/button/Primary';
import FormTextField from '../components/FormTextField';

const useStyles = makeStyles((theme) => ({
    label: {
        color: '#3e4555',
        fontFamily: 'Gotham',
        fontSize: 14,
        fontWeight: 'bold',
    },
    addColumn: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
}));

const OptionsView = (props) => {
    const classes = useStyles();
    const form = useFormikContext();

    const sizes = form.values.productOptions.size;

    const {state, dispatch} = props

    const removeSize = (size) => {
        const sizes = form.values.productOptions.size;
        form.setFieldValue(
            'productOptions.size',
            sizes.filter(({ SKU }) => SKU !== size.SKU),
        );
    };

    const addNewSize = (size) => {
        const sizes = form.values.productOptions.size;

        const isDuplicateSKU = sizes.some(({ SKU }) => SKU === size.SKU);
        if (isDuplicateSKU) {
            return {
                succeeded: false,
                error: {
                    field: 'SKU',
                    message: `SKU ${size.SKU} already exists`,
                },
            };
        }

        const isDuplicateSize = sizes.some(({ value }) => value === size.value);
        if (isDuplicateSize) {
            return {
                succeeded: false,
                error: {
                    field: 'value',
                    message: `Size ${size.value} already exists`,
                },
            };
        }

        form.setFieldValue('productOptions.size', [...sizes, size]);
        return { succeeded: true };
    };

    return (
        <>
            <Grid container spacing={4}>
                <Grid className={classes.label} item xs={1}>
                    Size
                </Grid>
                <Grid className={classes.label} item xs={3}>
                    SKU
                </Grid>
                <Grid className={classes.label} item xs={3}>
                    EAN Code
                </Grid>
                <Grid className={classes.label} item xs={2}>
                    Stock Items
                </Grid>
                <Grid className={classes.label} item xs={1}>
                    Delete
                </Grid>
                <Grid className={classes.label} item xs={2}></Grid>
            </Grid>
            {sizes.map((size, index, arr) => {
                return (
                    <Grid container spacing={4} key={size.SKU}>
                        <Grid item xs={1}>
                            <FormTextField name={`productOptions.size.${index}.value`} />
                        </Grid>
                        <Grid item xs={3}>
                            <FormTextField name={`productOptions.size.${index}.SKU`} />
                        </Grid>
                        <Grid item xs={3}>
                            <FormTextField name={`productOptions.size.${index}.eanCode`} />
                        </Grid>
                        <Grid item xs={2}>
                            <FormTextField name={`productOptions.size.${index}.stockLevel`} type="number" />
                        </Grid>
                        <Grid item xs={1}>
                            <IconButton onClick={() => removeSize(size)}>
                                <DeleteOutlinedIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={2}></Grid>
                    </Grid>
                );
            })}
            <Formik
                initialValues={state}
                enableReinitialize={true}
                validationSchema={ProductOptionSchema}
                validateOnMount={true}
                onSubmit={(values, actions) => {
                    const { succeeded, error } = addNewSize(values);
                    if (succeeded) {
                        actions.resetForm();
                        actions.setErrors({});
                        dispatch({ type: 'RESET' });
                    } else {
                        actions.setFieldError(error.field, error.message);
                    }
                    actions.setSubmitting(false);
                }}
            >
                {(newSizeForm) => {
                    const handleKeyUp = (e) => e.key === 'Enter' && newSizeForm.submitForm();
                    return (
                        <Grid container spacing={4}>
                            <Grid item xs={1}>
                                <FormTextField name="value" onKeyUp={handleKeyUp} onChangeInput={(e) => {
                                    dispatch({ type: 'EDIT_VALUE', payload: e.currentTarget.value });
                                }}/>
                            </Grid>
                            <Grid item xs={3}>
                                <FormTextField name="SKU" onKeyUp={handleKeyUp} onChangeInput={(e) => {
                                    dispatch({ type: 'EDIT_SKU', payload: e.currentTarget.value });
                                }}/>
                            </Grid>
                            <Grid item xs={3}>
                                <FormTextField name="eanCode" onKeyUp={handleKeyUp} onChangeInput={(e) => {
                                    dispatch({ type: 'EDIT_EAN', payload: e.currentTarget.value });
                                }}/>
                            </Grid>
                            <Grid item xs={2}>
                                <FormTextField name="stockLevel" onKeyUp={handleKeyUp} onChangeInput={(e) => {
                                    dispatch({ type: 'EDIT_STOCK_LEVEL', payload: e.currentTarget.value });
                                }}/>
                            </Grid>
                            <Grid item xs={1}></Grid>
                            <Grid item xs={2} className={classes.addColumn}>
                                <PrimaryButton onClick={newSizeForm.submitForm}>Add Size</PrimaryButton>
                            </Grid>
                        </Grid>
                    );
                }}
            </Formik>
        </>
    );
};

export default OptionsView;
